import { classnames } from '@/utils/classnames';

interface IHorizontalPaddingLayoutProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export const HorizontalPaddingLayout: React.FC<
  React.PropsWithChildren<IHorizontalPaddingLayoutProps>
> = ({ className, children }) => {
  return (
    <div className={classnames('flex flex-grow flex-col px-5', className)}>
      {children}
    </div>
  );
};
